if (!window.cardVariantSelectorInitialized) {
  window.cardVariantSelectorInitialized = true;

  document.addEventListener('change', function (event) {
    const selector = event.target.closest('[data-card-variant-selector]');
    if (!selector) return;

    const card = selector.closest('.card-wrapper') || selector.closest('.card');
    const form = selector.closest('form');
    const option = selector.options[selector.selectedIndex];
    if (!card || !option) return;

    const image = card.querySelector('.card-product__image');
    const submitButton = form ? form.querySelector('[name="add"]') : null;
    const buttonText = submitButton ? submitButton.querySelector('span:not(.sold-out-message)') : null;
    const priceContainer = card.querySelector('[data-card-price]');
    const priceTemplates = card.querySelector('[data-card-price-templates]');

    const available = option.dataset.available === 'true';

    if (image && option.dataset.imageSrc) {
      image.src = option.dataset.imageSrc;
      if (option.dataset.imageSrcset) image.srcset = option.dataset.imageSrcset;
      if (option.dataset.imageAlt) image.alt = option.dataset.imageAlt;
      if (option.dataset.imageWidth) image.width = option.dataset.imageWidth;
      if (option.dataset.imageHeight) image.height = option.dataset.imageHeight;
    }

    if (priceContainer && priceTemplates) {
      const template = priceTemplates.querySelector('[data-variant-id="' + option.value + '"]');
      if (template) priceContainer.innerHTML = template.innerHTML;
    }

    if (submitButton) submitButton.disabled = !available;

    if (buttonText) {
      buttonText.textContent = available
        ? selector.dataset.addToCartText || buttonText.textContent
        : selector.dataset.soldOutText || buttonText.textContent;
    }
  });
}
